module.exports = __webpack_public_path__ + "img/horizontal_3_5_9005.e7e55d92.png";